import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {BulkTaxReportComponent} from "./bulk-tax-report.component";

export const bulktaxReportRoutes: Routes = [
  {
    path:'bulktaxReport',
    component: BulkTaxReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(bulktaxReportRoutes)],
  exports: [RouterModule]
})
export class BulkTaxReportRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/bulk-tax-report/bulk-tax-report-routing.module.ts